import React, { Component } from 'react'
import MUIDataTable from "mui-datatables";
import { IconButton } from '@material-ui/core';
import Launch from '@material-ui/icons/Launch';
import ZoomOutMap from '@material-ui/icons/ZoomOutMap';
import Add from '@material-ui/icons/Add';



export default class CourseTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoaded: false
        }
    }



    handleDelete(rowsDeleted) {
        console.log(rowsDeleted)
    }

    onActionClick(el){
        this.props.actionClick(el);
    }

    onClick() {
        console.log("hey");
    }

    onViewClick(el) {
        this.props.onViewClick(el);
    }


    render() {
        const columns = [
            {
                name: "Type",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "Department Code",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "Name",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "Phone",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "Email",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "View",
                options: {
                    filter: false,
                    sort: false,
                }
            },
            {
                name: "Action",
                options: {
                    filter: false,
                    sort: false,
                    download: false
                }
            }
        ];

        const options = {
            filterType: 'checkbox',
            selectableRows: false,
            responsive: 'scroll',
            onRowsDelete: (rowsDeleted) => {
                this.handleDelete(rowsDeleted)
            },
            customToolbar: () => {
                return (
                    <IconButton onClick={this.props.onAddClick} ><Add /></IconButton>
                )
            }
        };

        let data = [];
        let table_data = this.props.table_data;
        //console.log(table_data);
        if(table_data.length > 0){
            data = table_data.map((el,index)=>
                [
                    el.type, 
                    el.dept_code, 
                    el.name, 
                    el.phone, 
                    el.email, 
                    <ZoomOutMap onClick={this.onViewClick.bind(this, el)} />, 
                    <Launch onClick={this.onActionClick.bind(this,el)} />
                ]
            )
        }else{
            data= [];
        }

        return (
            <div>
                <MUIDataTable
                    title={"Employee List"}
                    data={data}
                    columns={columns}
                    options={options}

                />
            </div>
        )


    }
}



// WEBPACK FOOTER //
// ./src/Components/Employee/Add/EmployeeTable.js